var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioButtonUnchecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "radio_button_unchecked"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1241_6083",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1241_6083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "radio_button_unchecked_2",
    d: "M8.00217 15.0832C7.02284 15.0832 6.10267 14.8995 5.24167 14.5319C4.38078 14.1642 3.6285 13.6586 2.98484 13.0149C2.34117 12.3712 1.8355 11.6197 1.46784 10.7604C1.10028 9.90096 0.916504 8.98157 0.916504 8.00224C0.916504 7.01179 1.10028 6.08607 1.46784 5.22507C1.8355 4.36418 2.34028 3.61435 2.98217 2.97557C3.62406 2.3369 4.37512 1.83129 5.23534 1.45874C6.09567 1.08618 7.01595 0.899902 7.99617 0.899902C8.9875 0.899902 9.91434 1.08574 10.7767 1.4574C11.6389 1.82918 12.3889 2.33368 13.0268 2.9709C13.6647 3.60812 14.1697 4.3574 14.5417 5.21874C14.9138 6.08018 15.0998 7.00724 15.0998 7.9999C15.0998 8.98079 14.9136 9.90162 14.541 10.7624C14.1684 11.6232 13.6628 12.3747 13.0242 13.0171C12.3854 13.6593 11.6363 14.1642 10.777 14.5319C9.91756 14.8995 8.99262 15.0832 8.00217 15.0832ZM7.99984 13.5166C9.53317 13.5166 10.8359 12.9812 11.9082 11.9104C12.9804 10.8396 13.5165 9.53613 13.5165 7.9999C13.5165 6.46657 12.9804 5.16379 11.9082 4.09157C10.8359 3.01935 9.53039 2.48324 7.9915 2.48324C6.46373 2.48324 5.16373 3.01935 4.0915 4.09157C3.01928 5.16379 2.48317 6.46935 2.48317 8.00824C2.48317 9.53601 3.01856 10.836 4.08934 11.9082C5.16012 12.9805 6.46361 13.5166 7.99984 13.5166Z",
    fill: "#6A777F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonUnchecked);
export default __webpack_public_path__ + "static/media/radio_button_unchecked.7975ce61b5b82e6681074057b6adc1e0.svg";
export { ForwardRef as ReactComponent };